<template>

  <div 
    class="form-inline"
    :class="{'box-loading': loading}">
    
    <div class="form-group mr-2">
      <label class="mr-2">
        <strong>{{ $t('Duplicates') }}</strong>
      </label>

      <div class="btn-group">
        <button 
          type="button" 
          class="btn"
          v-for="(duplicate, index) in duplicates"
          :key="index"
          :class="{'btn-outline-secondary': duplicate._id !== candidate._id, 'btn-secondary': duplicate._id === candidate._id}" 
          @click="selectCandidate(duplicate._id)">
          #{{ index + 1 }}
          </button>
      </div>
    </div>
    
    <div class="form-group">
      <button 
        type="button" 
        class="btn btn-secondary" 
        @click="merge()">
        {{ $tc('merge_n_candidates', duplicates.length, {count: duplicates.length}) }}
        </button>
    </div>

  </div>
  
</template>

<script>
export default {
  name: 'CandidateDuplicates',
  components: {
  },
  props: [
  ],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    duplicates () {
      return this.$store.getters.getDuplicates
    }
  },
  created () {
  },
  methods: {
    /*
    merge
    */
    merge () {
      const mergeAction = () => {
        this.loading = true

        this.$store
        .dispatch('mergeCandidate', {
          candidate_id: this.candidate._id
        })
        .then((result) => {
          this.$store.dispatch('selectCandidate', this.candidate._id)
          this.$store.dispatch('refreshSelectActivities')
          this.$store.dispatch('refreshSelectCandidates')
          this.$store.dispatch('refreshSelectCandidateBoard')
          this.$store.dispatch('selectDuplicates', {candidate_id: this.candidate._id})
          this.loading = false
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: mergeAction,
        title: 'Deseja realmente unir os candidatos semelhantes?',
        mesage: 'Essa operação não poderá ser desfeita.',
        style: 'primary'
      })
    },
    selectCandidate (id) {
      this.$openCandidateModal(id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Duplicates/CandidateDuplicates.vue